import {z} from '@hono/zod-openapi';

/** The grammar the DMS template engine resolves and the placeholder checks on both sides recognise. */
const PLACEHOLDER_LITERAL_PATTERN = /^\{\{\s*[\w.]+\s*\}\}$/;

/**
 * One entry of a template's variable catalogue. A template has no record, so the variables it
 * may use ground a message the way record facts ground one written from a record.
 */
export const composeMessagePlaceholderSchema = z
  .object({
    /** The exact token to emit, for example `{{ vehicle.title }}`. */
    literal: z
      .string()
      .min(1)
      .max(128)
      .regex(PLACEHOLDER_LITERAL_PATTERN, 'Expected a {{ placeholder }} token'),
    /** The human name the template editor shows on the chip, for example `Vehicle - Title`. */
    label: z.string().min(1).max(128),
  })
  .strict()
  .openapi('ComposeMessagePlaceholder');

export type ComposeMessagePlaceholder = z.infer<typeof composeMessagePlaceholderSchema>;
